export const WHATSAPP_URL =
  "https://wa.me/5585996563400?text=Ol%C3%A1%2C%20gostaria%20de%20solicitar%20um%20or%C3%A7amento%20de%20levantamento%20topogr%C3%A1fico.";

export const PHONE_DISPLAY = "(85) 99656-3400";
export const PHONE_TEL = "+5585996563400";
export const EMAIL = "dm.levantamentos@gmail.com";
export const LOCATION = "Fortaleza - CE";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
